import { Link } from "react-router-dom";

export type LegalSection = {
  id: string;
  title: string;
  content: React.ReactNode;
};

export function LegalPage({ eyebrow, title, intro, effectiveDate, sections }: {
  eyebrow: string;
  title: string;
  intro: string;
  effectiveDate: string;
  sections: LegalSection[];
}) {
  return (
    <main id="main" className="legal-page">
      <header className="legal-hero">
        <div className="shell legal-hero__inner">
          <div>
            <p className="eyebrow"><span /> {eyebrow}</p>
            <h1>{title}</h1>
          </div>
          <div className="legal-hero__summary">
            <p>{intro}</p>
            <span>Effective {effectiveDate}</span>
          </div>
        </div>
      </header>

      <div className="shell legal-layout">
        <aside className="legal-nav" aria-label={`${title} contents`}>
          <p>On this page</p>
          <nav>{sections.map((section, index) => <a href={`#${section.id}`} key={section.id}><span>{String(index + 1).padStart(2, "0")}</span>{section.title}</a>)}</nav>
        </aside>
        <article className="legal-document">
          {sections.map((section, index) => (
            <section id={section.id} key={section.id}>
              <span className="legal-document__number">{String(index + 1).padStart(2, "0")}</span>
              <div><h2>{section.title}</h2>{section.content}</div>
            </section>
          ))}
          <footer className="legal-contact">
            <p>Questions about this document?</p>
            <a href="mailto:support@chuno.work">support@chuno.work</a>
            <div><Link to="/privacy">Privacy Policy</Link><Link to="/terms">Terms of Service</Link></div>
          </footer>
        </article>
      </div>
    </main>
  );
}
